/**
 * Icon — wrapper sobre o lucide-react (ícones profissionais, stroke consistente).
 * Mantém a API <Icon name="pin" size={18} color="..." /> usada em toda a app.
 * Substitui emojis estruturais (regra no-emoji-icons do design system).
 */
import React from 'react';
import {
  Home, MapPin, Calendar, Scale, Bell, Search, Star, Check, CircleCheck, Zap, Wallet,
  ShieldCheck, User, Briefcase, Clock, Map, Inbox, Smartphone, Plus, X,
  ArrowRight, ArrowLeft, Send, Camera, ShoppingBag, Sparkles, Trophy, Droplet, Leaf,
  Paintbrush, Wrench, Snowflake, Package, LogOut, MessageSquare, Upload, Mail,
  Utensils, Hammer, Truck, BookOpen, Laptop, Users, Sprout, Sun, Moon,
  LayoutGrid, Settings, BarChart3, LockKeyhole, IdCard, TriangleAlert,
} from 'lucide-react';

const MAP = {
  home: Home,
  pin: MapPin,
  calendar: Calendar,
  scale: Scale,
  bell: Bell,
  search: Search,
  star: Star,
  check: Check,
  circleCheck: CircleCheck,
  bolt: Zap,
  wallet: Wallet,
  shield: ShieldCheck,
  user: User,
  briefcase: Briefcase,
  clock: Clock,
  map: Map,
  inbox: Inbox,
  phone: Smartphone,
  plus: Plus,
  x: X,
  arrowRight: ArrowRight,
  arrowLeft: ArrowLeft,
  send: Send,
  camera: Camera,
  bag: ShoppingBag,
  spark: Sparkles,
  trophy: Trophy,
  droplet: Droplet,
  leaf: Leaf,
  paint: Paintbrush,
  wrench: Wrench,
  snow: Snowflake,
  box: Package,
  logout: LogOut,
  chat: MessageSquare,
  upload: Upload,
  mail: Mail,
  utensils: Utensils,
  hammer: Hammer,
  truck: Truck,
  book: BookOpen,
  laptop: Laptop,
  users: Users,
  sprout: Sprout,
  sun: Sun,
  moon: Moon,
  grid: LayoutGrid,
  settings: Settings,
  chart: BarChart3,
  lock: LockKeyhole,
  identity: IdCard,
  alert: TriangleAlert,
};

const Icon = ({ name, size = 18, color = 'currentColor', strokeWidth = 1.9, style, className, ...rest }) => {
  const Cmp = MAP[name];
  if (!Cmp) return null;
  return (
    <Cmp
      size={size}
      color={color}
      strokeWidth={strokeWidth}
      absoluteStrokeWidth
      className={className}
      aria-hidden="true"
      style={{ flexShrink: 0, verticalAlign: 'middle', ...style }}
      {...rest}
    />
  );
};

export default Icon;
